import nameof from "ts-nameof.macro";
import { ExportFileResult, MatriculaEditModel, ModelValidationResult, PedidosTiendaSearch, PedidoTiendaDetailResult, PedidoTiendaInformeCompletoMessage, PedidoTiendaListItemPaginatedList } from "../models/dataModels";
import { ApiFetcher } from "../utils/ApiFetcher";
import { IServiceForEdit, IServiceForIndex } from "../utils/base/BaseServices";
import { downloadFileFromBase64Array } from "../utils/ValuesFormatter";


export class PedidosTiendaService
    implements IServiceForIndex<PedidosTiendaSearch, PedidoTiendaListItemPaginatedList>, IServiceForEdit<PedidoTiendaDetailResult> {


    search(searchData: PedidosTiendaSearch): Promise<PedidoTiendaListItemPaginatedList> {

        var apiFetcher = new ApiFetcher();
        var prom = apiFetcher.post<PedidosTiendaSearch, PedidoTiendaListItemPaginatedList>("intranet/pedidos-tienda/search", searchData);

        prom.then(res => {

            res.items.forEach((val) => {
                val.fechaPedido = val.fechaPedido != null ? new Date(val.fechaPedido) : null;
            });

            return res;
        });

        return prom;
    }

    delete(id: number): Promise<any> {
        throw new Error("Not Implemented");
    }

    getById(id: string | number): Promise<PedidoTiendaDetailResult> {

        var apiFetcher = new ApiFetcher();
        var prom = apiFetcher.getByUrl<PedidoTiendaDetailResult>(`intranet/pedidos-tienda/${id}`);
        prom = prom.then(model => {

            model.fechaPedido = model.fechaPedido == null ? null : new Date(model.fechaPedido);
            model.procesadoTiendaV2 = model.procesadoTiendaV2 == null ? null : new Date(model.procesadoTiendaV2);
            return model;
        });
        return prom;
    }

    validate(model: PedidoTiendaDetailResult): Promise<ModelValidationResult> {
        return Promise.resolve({
            isOk: true,
            validationErrors: {}
        } as ModelValidationResult);
    }

    create(model: PedidoTiendaDetailResult): Promise<PedidoTiendaDetailResult> {
        throw new Error("Method not implemented.");
    }

    update(id: number, model: PedidoTiendaDetailResult): Promise<PedidoTiendaDetailResult> {


        var apiFetcher = new ApiFetcher();
        var prom = apiFetcher.put<PedidoTiendaDetailResult, PedidoTiendaDetailResult>(`intranet/pedidos-tienda/${id}`, model);
        return prom;

    }

    exportExcel(search: PedidosTiendaSearch): Promise<any> {
        var url = "intranet/pedidos-tienda/exportExcel";

        var apiFetcher = new ApiFetcher();
        var promise = apiFetcher.post<PedidosTiendaSearch, ExportFileResult>(url, search)
            .then((result) => {
                downloadFileFromBase64Array(result.content, result.fileName, "application/octet-stream");
                return result;
            });
        return promise;
    }

    exportExcelCompleto(search: PedidosTiendaSearch): Promise<any> {
        var url = "intranet/pedidos-tienda/exportExcelCompleto";

        var modelo = {
            ...search
        } as PedidoTiendaInformeCompletoMessage;

        var apiFetcher = new ApiFetcher();
        var promise = apiFetcher.post<PedidoTiendaInformeCompletoMessage, ExportFileResult>(url, modelo)
            .then((result) => {
                downloadFileFromBase64Array(result.content, result.fileName, "application/octet-stream");
                return result;
            });
        return promise;
    }


    exportJson(pedidoId: number): Promise<any> {
        var url = "intranet/pedidos-tienda/exportExcel";

        var apiFetcher = new ApiFetcher();
        var prom = apiFetcher.getByUrl<ExportFileResult>(`intranet/pedidos-tienda/${pedidoId}/jsonPedido`)
            .then((result) => {
                downloadFileFromBase64Array(result.content, result.fileName, "application/octet-stream");
                return result;
            });

        return prom;
    }


}